import { render } from "./DSS.vue?vue&type=template&id=36eac730&scoped=true"
import script from "./DSS.vue?vue&type=script&lang=js"
export * from "./DSS.vue?vue&type=script&lang=js"

import "./DSS.vue?vue&type=style&index=0&id=36eac730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36eac730"]])

export default __exports__